document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },
        pagination: {
            clickable: true,
            el: ".swiper-pagination",
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let sliders = document.querySelectorAll(".single-quad-swiper");
    sliders.forEach((slider) => {
        let single_slider = new Swiper(slider, {
            loop: true,
            effect: "fade",
            speed: 1000,
            fadeEffect: {
            crossFade: true,
            },
            navigation: {
                nextEl: slider.querySelector('.sw-gal-next'),
                prevEl: slider.querySelector('.sw-gal-prev'),
            },
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
            }
        });
    });

    let feature_events = new Swiper(".feature_events-swiper", {
        loop: true,
        effect: "fade",
        speed: 1000,
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination-events",
            type: "fraction",
            formatFractionCurrent: function (number) {
                return number < 10 ? number : number;
            },
            formatFractionTotal: function (number) {
                return number < 10 ? number : number;
            },
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
    });

    let rooms = new Swiper(".rooms__slider", {
        speed: 1000,
        loop:true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
    });

    let quadGalleryThree = new Swiper('.gallery-default__slider', {
        speed: 700,
        loop: true,
        spaceBetween: 20,
        slidesPerView: 0,
        navigation: {
            prevEl: '.sw-gal-prev',
            nextEl: '.sw-gal-next'
        },
        
        breakpoints: {
            640: { 
                slidesPerView: 1 
            },
            768: { 
                slidesPerView: 2 
            },
            1024: { 
                slidesPerView: 3
            }
        } 
    });

    let sliderBackground = new Swiper('.slider__background', {
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.sw-gal-next',
            prevEl: '.sw-gal-prev'
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        }
    });

    let left__slider = new Swiper('.left__slider', {
        loop: true,
        speed: 1500,
    });

    let right__slider = new Swiper('.right__slider', {
        loop: true,
        speed: 1500,
    });

    sliderBackground.controller.control = [left__slider,right__slider];


    let logos = new Swiper(".logos-slider-block", {
        speed: 700,
        loop:true,
        slidesPerView: 6,
        spaceBetween: 40,
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 40,
            },
            640: {
                slidesPerView: 6,
                spaceBetween: 40,
            }
        },
    });

    let roomsAmenities = new Swiper(".room-entry__amenities-slider-swiper", {
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
});